import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import TagModal from "./ModalComponent";

const CustomFieldsComponent = ({
  view,
  customFields,
  setCustomFields,
  checkpoints,
  setCheckpoints,
  isEdit,
  selectedPier,
  selectedTt,
  active,
  errors,
  currentProject
}) => {
  const currentFields = customFields[view] || [];
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);

  useEffect(() => {
    const hasCustomFieldErrors = errors?.customFields?.[view]?.some((field) =>
      Object.values(field || {}).some(Boolean)
    );
    const hasCheckpointErrors = errors?.checkpoints?.[view]?.some((cp) =>
      Object.values(cp || {}).some(Boolean)
    );
    if (hasCustomFieldErrors || hasCheckpointErrors) {
      setShowErrorSnackbar(true);
    } else {
      setShowErrorSnackbar(false);
    }
  }, [errors, view]);

  const updateFieldAtIndex = (index, changes) => {
    const updatedFields = currentFields.map((item, i) =>
      i === index ? { ...item, ...changes } : item
    );
    setCustomFields((prev) => ({ ...prev, [view]: updatedFields }));
  };

  const handleAddFields = () => {
    const visibleCount = currentFields.filter((item) => !item.delete).length;
    if (visibleCount >= 3) return;
    const newFields = [
      ...currentFields,
      { name: "Custom label", type: "", values: {} },
    ];
    setCustomFields((prev) => ({ ...prev, [view]: newFields }));
  };

  const handleDelete = (index) => {
    const updatedFields = currentFields.map((item, i) =>
      i === index ? { ...item, delete: true } : item
    );
    setCustomFields((prev) => ({ ...prev, [view]: updatedFields }));
  };

  const handleChangeName = (index, newName) => {
    updateFieldAtIndex(index, { name: newName });
  };

  const handleChangeType = (newType, index) => {
    setCurrent(index);
    if (newType === 3) {
      updateFieldAtIndex(index, { type: newType });
      setOpen(true);
    } else {
      updateFieldAtIndex(index, { type: newType });
    }
  };

  const handleAddCheckpoint = () => {
    setCheckpoints((prev) => ({
      ...prev,
      [view]: [
        ...prev[view],
        {
          name: "",
          acceptance_criteria: "",
          inspection_type: "",
        },
      ],
    }));
  };

  const handleChange = (index, field, value) => {
    setCheckpoints((prev) => {
      const updated = [...prev[view]];
      updated[index] = { ...updated[index], [field]: value };
      return {
        ...prev,
        [view]: updated,
      };
    });
  };

  const handleDeleteCheckpoints = (index) => {
    setCheckpoints((prev) => {
      const updated = prev[view].map((item, i) =>
        i === index ? { ...item, delete: true } : item
      );
      return {
        ...prev,
        [view]: updated,
      };
    });
  };

  const handleOpen = (index) => {
    setCurrent(index);
    setOpen(true);
  };

  useEffect(() => {
    if (!checkpoints[view] || checkpoints[view].length === 0) {
      setCheckpoints((prev) => ({
        ...prev,
        [view]: [
          {
            name: "",
            acceptance_criteria: "",
            inspection_type: "",
          },
        ],
      }));
    }
  }, [checkpoints, view, setCheckpoints]);

  // useEffect(() => {
  //   if (currentFields?.length === 0 && active !== "checklist") {
  //     const newFields = [
  //       ...currentFields,
  //       { name: "Custom label", type: "", values: {} },
  //     ];
  //     setCustomFields((prev) => ({ ...prev, [view]: newFields }));
  //   }
  //   // eslint-disable-next-line
  // }, [active, view]);

  return (
    <Box sx={{ height: active !== "checklist" && currentProject?.type === 1 ? "calc(100vh - 450px)" : active === "checklist" ? "calc(100vh - 290px)" : "calc(100vh - 340px)", overflow: "auto" }}>
      <Snackbar
        open={showErrorSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setShowErrorSnackbar(false)}
        autoHideDuration={5000}
      >
        <Alert severity="error" onClose={() => setShowErrorSnackbar(false)}>
          Please fill all the field and proceed save
        </Alert>
      </Snackbar>

      <Box>
        <Box p={2}>
          {currentFields
            .map((item, index) => ({ ...item, index }))
            .filter((item) => !item.delete)
            .map(({ index, ...item }) => (
              <Box
                key={index}
                display="flex"
                flexDirection="column"
                gap={1}
                mb={3}
              >
                {index === 0 && active !== "checklist" && (
                  <Box display="flex" gap={4} mb={1}>
                    <Box
                      sx={{ minWidth: 240, fontWeight: "bold", fontSize: 18 }}
                    >
                      Label
                    </Box>
                    <Box sx={{ width: 48 }} />
                    <Box
                      sx={{ minWidth: 240, fontWeight: "bold", fontSize: 18 }}
                    >
                      {view === "piers"
                        ? `Pier ${ currentProject?.type === 0 ? selectedPier?.[0]?.pier_part_label :selectedPier?.[0]?.pier_part_order}`
                        : `${selectedTt?.[0]?.tt_part_label}`}
                    </Box>
                  </Box>
                )}

                <Box display="flex" alignItems="center" gap={4}>
                  <TextField
                    label="Custom Label"
                    value={item.name}
                    onChange={(e) => handleChangeName(index, e.target.value)}
                    disabled={!isEdit}
                    sx={{ minWidth: 240 }}
                  />

                  <Select
                    value={item.type}
                    displayEmpty
                    sx={{ height: "52px", minWidth: 240 }}
                    onChange={(e) =>
                      handleChangeType(e.target.value, index)
                    }
                    disabled={!isEdit}
                  >
                    <MenuItem value="">Select Type</MenuItem>
                    <MenuItem value={0}>Integer</MenuItem>
                    <MenuItem value={1}>Float</MenuItem>
                    <MenuItem value={2}>Free Text</MenuItem>
                    <MenuItem value={3}>Dropdown</MenuItem>
                  </Select>

                  {isEdit && (
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}

                  {item?.values?.values?.length > 0 && isEdit && (
                    <Box
                      sx={{
                        color: "#f16253",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOpen(index)}
                    >
                      View & edit dropdown options
                    </Box>
                  )}
                </Box>
              </Box>
            ))}

          {currentFields.filter((item) => !item.delete).length < 3 && (
            <Button
              variant="outlined"
              onClick={handleAddFields}
              disabled={!isEdit}
            >
              + Add Custom Fields
            </Button>
          )}
        </Box>

        <Box p={2}>
          {checkpoints[view]
            ?.filter((item) => !item.delete)
            .map((item, index) => (
              <Box key={index} mb={2}>
                <Box display="flex" alignItems="center" gap={2}>
                  <TextField
                    fullWidth
                    label="Checkpoint"
                    value={item.name}
                    onChange={(e) =>
                      handleChange(index, "name", e.target.value)
                    }
                    disabled={!isEdit}
                  />
                  <TextField
                    fullWidth
                    label="Acceptance Criteria"
                    value={item.acceptance_criteria}
                    onChange={(e) =>
                      handleChange(index, "acceptance_criteria", e.target.value)
                    }
                    disabled={!isEdit}
                  />
                  <TextField
                    fullWidth
                    label="Inspection Type"
                    value={item.inspection_type}
                    onChange={(e) =>
                      handleChange(index, "inspection_type", e.target.value)
                    }
                    disabled={!isEdit}
                  />
                  {isEdit && (
                    <IconButton
                      color="error"
                      onClick={() => handleDeleteCheckpoints(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>
              </Box>
            ))}

          <Button
            variant="outlined"
            onClick={handleAddCheckpoint}
            disabled={!isEdit}
          >
            + Add Checkpoint
          </Button>
        </Box>

        <TagModal
          open={open}
          setOpen={setOpen}
          setCustomFields={setCustomFields}
          view={view}
          current={current}
          data={currentFields?.[current]?.values?.values}
        />
      </Box>
    </Box>
  );
};

export default CustomFieldsComponent;
